/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 * (This should be the overall Error object `{ "$ref": "#" }`, but that causes the serializer builder to blow its stack due to not handling circular serialization references.)
 * @export
 * @interface ErrorDetails
 */
export interface ErrorDetails {
  /**
   *
   * @type {string}
   * @memberof ErrorDetails
   */
  code?: string
  /**
   *
   * @type {string}
   * @memberof ErrorDetails
   */
  message?: string
}

export function ErrorDetailsFromJSON(json: any): ErrorDetails {
  return ErrorDetailsFromJSONTyped(json, false)
}

export function ErrorDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ErrorDetails {
  if (json === undefined || json === null) {
    return json
  }
  return {
    code: !exists(json, 'code') ? undefined : json['code'],
    message: !exists(json, 'message') ? undefined : json['message'],
  }
}

export function ErrorDetailsToJSON(value?: ErrorDetails | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    code: value.code,
    message: value.message,
  }
}
